import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useIsCircleAiEnabled } from "@circle-react/components/CircleAi/useCircleAiFeatureFlags";
import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";
import { IconButton } from "@circleco/compass/components/IconButton";
import { useMatchRoute, useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";

import { NewChatButton } from "../Home/NewChatButton";
import { RecentChatsToggleButton } from "../Home/RecentChatsDrawer/RecentChatsToggleButton";
import { useCircleAiStore } from "../useCircleAiStore";
import { useIsCircleAiPageRoute } from "../useIsCircleAiPageRoute";
import { CircleAIDockNavRow } from "./CircleAIDockNavRow";

const AI_SKILLS_PATH = "/ai/skills" as const;

export const CircleAIDockSection = () => {
  const isAdmin = useIsCommunityAdmin();
  const isCircleAiEnabled = useIsCircleAiEnabled();
  const dockMode = useCircleAIShellStore(s => s.dockMode);
  const isRecentChatsOpen = useCircleAiStore(s => s.isRecentChatsOpen);
  const toggleRecentChats = useCircleAiStore(s => s.toggleRecentChats);
  const startNewChat = useCircleAiStore(s => s.startNewChat);
  const { isFullPageAiRoute } = useIsCircleAiPageRoute();
  const navigate = useNavigate();
  const matchRoute = useMatchRoute();
  const isSkillsActive = Boolean(matchRoute({ to: AI_SKILLS_PATH }));
  const goToSkills = () => void navigate({ to: AI_SKILLS_PATH });

  if (!isAdmin || !isCircleAiEnabled) return null;

  if (dockMode === "collapsed") {
    return (
      <div className="flex flex-col items-center gap-2 p-3">
        <NewChatButton />
        <RecentChatsToggleButton />
        <IconButton
          icon="ai-box-filled"
          variant={isSkillsActive ? "secondary" : "ghost"}
          aria-label={t("circle_ai_skills.nav.skills")}
          onClick={goToSkills}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-0.5 px-3 py-2">
      <CircleAIDockNavRow
        icon="circle-plus-filled"
        label={t("circle_ai_home.new_chat")}
        onClick={() => startNewChat({ openPanel: !isFullPageAiRoute })}
      />
      <CircleAIDockNavRow
        icon="clock-dash"
        label={t("circle_ai_home.recent_chats_drawer.open")}
        isActive={isRecentChatsOpen}
        onClick={toggleRecentChats}
      />
      <CircleAIDockNavRow
        icon="ai-box-filled"
        label={t("circle_ai_skills.nav.skills")}
        isActive={isSkillsActive}
        onClick={goToSkills}
      />
    </div>
  );
};
